import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgExtensionUnknown = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 17,
	height: 17,
	viewBox: "0 0 17 17",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_23355_330)",
		children: [/* @__PURE__ */ _jsx("path", {
			d: "M14.9221 0.346191H2.07773C1.12143 0.346191 0.346191 1.12143 0.346191 2.07773V14.9221C0.346191 15.8784 1.12143 16.6536 2.07773 16.6536H14.9221C15.8784 16.6536 16.6536 15.8784 16.6536 14.9221V2.07773C16.6536 1.12143 15.8784 0.346191 14.9221 0.346191Z",
			fill: "#F3EBFF",
			stroke: "#CEBEE8",
			strokeWidth: .692614
		}), /* @__PURE__ */ _jsx("g", {
			clipPath: "url(#clip1_23355_330)",
			children: /* @__PURE__ */ _jsx("path", {
				d: "M10.7499 11.249C10.8245 11.249 10.896 11.2194 10.9488 11.1666C11.0015 11.1139 11.0311 11.0424 11.0311 10.9678V9.46694C11.1812 9.53793 11.3467 9.56982 11.5124 9.55966C11.6781 9.5495 11.8385 9.49761 11.9787 9.40882C12.119 9.32003 12.2345 9.19722 12.3145 9.05181C12.3946 8.9064 12.4365 8.74312 12.4365 8.57713C12.4365 8.41115 12.3946 8.24786 12.3145 8.10245C12.2345 7.95704 12.119 7.83423 11.9787 7.74544C11.8385 7.65665 11.6781 7.60477 11.5124 7.59461C11.3467 7.58444 11.1812 7.61634 11.0311 7.68733V6.18651C11.0311 6.11192 11.0015 6.04038 10.9488 5.98764C10.896 5.93489 10.8245 5.90526 10.7499 5.90526H9.10845C9.17952 5.75522 9.21148 5.58965 9.20137 5.42394C9.19126 5.25823 9.1394 5.09777 9.05062 4.95748C8.96184 4.8172 8.83902 4.70164 8.69359 4.62157C8.54816 4.5415 8.38484 4.49951 8.21882 4.49951C8.05281 4.49951 7.88948 4.5415 7.74405 4.62157C7.59862 4.70164 7.4758 4.8172 7.38702 4.95748C7.29824 5.09777 7.24639 5.25823 7.23628 5.42394C7.22616 5.58965 7.25813 5.75522 7.32919 5.90526H5.6874C5.61281 5.90526 5.54127 5.93489 5.48852 5.98764C5.43578 6.04038 5.40615 6.11192 5.40615 6.18651V7.68733C5.55618 7.61634 5.72173 7.58444 5.88741 7.59461C6.05308 7.60477 6.21349 7.65665 6.35373 7.74544C6.49396 7.83423 6.60947 7.95704 6.68951 8.10245C6.76955 8.24786 6.81152 8.41115 6.81152 8.57713C6.81152 8.74312 6.76955 8.9064 6.68951 9.05181C6.60947 9.19722 6.49396 9.32003 6.35373 9.40882C6.21349 9.49761 6.05308 9.5495 5.88741 9.55966C5.72173 9.56982 5.55618 9.53793 5.40615 9.46694V10.9678C5.40615 11.0424 5.43578 11.1139 5.48852 11.1666C5.54127 11.2194 5.61281 11.249 5.6874 11.249H10.7499Z",
				stroke: "#42296E",
				strokeWidth: .5,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			})
		})]
	}), /* @__PURE__ */ _jsxs("defs", { children: [/* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_23355_330",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 17,
			height: 17,
			fill: "white"
		})
	}), /* @__PURE__ */ _jsx("clipPath", {
		id: "clip1_23355_330",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 9,
			height: 9,
			fill: "white",
			transform: "matrix(-1 0 0 1 13 3.65527)"
		})
	})] })]
});
export default SvgExtensionUnknown;
